<h4 class="section_header" style="text-align: center">Activation du compte</h4>
<div class="row">
	<div class="col-md-6 offset-md-3">
		<div class="card">
			<div class="card-body" *ngIf="isConfirmed">
				<p class="mb-5 text-center">
					Pour finaliser l'activation de votre compte, vous devez configurer
					votre mot de passe.
				</p>

				<form [formGroup]="changePasswordForm" class="form-signin">
					<div class="form-row container">
						<div class="col-sm-12">
							<app-valid-input
								[inputType]="'password'"
								[control]="
									convertToFormControl(changePasswordForm.get('newPassword'))
								"
								[placeHolder]="'Mot de passe'"
							></app-valid-input>
							<app-valid-input
								[inputType]="'password'"
								[control]="
									convertToFormControl(
										changePasswordForm.get('newPasswordRepeated')
									)
								"
								[placeHolder]="'Répéter le mot de passe'"
							></app-valid-input>
							<div
								*ngIf="isFormError()"
								class="alert alert-danger"
								profile="alert"
							>
								<p *ngIf="changePasswordForm.errors.noMatchingPassword">
									Les mots de passe ne sont pas identiques
								</p>
							</div>
							<div class="row">
								<div class="col d-flex justify-content-end">
									<button
										class="btn btn-primary ml-2"
										style="color: white"
										(click)="changePassword()"
										[disabled]="changePasswordForm.invalid"
									>
										Valider
									</button>
								</div>
							</div>
						</div>
					</div>
				</form>

				<div
					class="alert alert-success alert-dismissible fade show"
					profile="alert"
					*ngIf="successfulChange"
				>
					<button
						type="button"
						class="close"
						data-dismiss="alert"
						aria-label="Close"
						(click)="closeAlerts()"
					>
						<span aria-hidden="true">&times;</span>
					</button>
					Mot de passe modifié avec succès !
				</div>
				<div
					class="alert alert-danger alert-dismissible fade show"
					profile="alert"
					*ngIf="unsuccessfulChange"
				>
					<button
						type="button"
						class="close"
						data-dismiss="alert"
						aria-label="Close"
						(click)="closeAlerts()"
					>
						<span aria-hidden="true">&times;</span>
					</button>
					Mot de passe non modifié : une erreur est survenue. Si l'erreur
					persiste, veuillez prendre contact avec un administrateur.
				</div>
			</div>
			<div class="card-body" *ngIf="!isConfirmed">
				<p class="mb-5 text-center">Accès non autorisé.</p>
			</div>
		</div>
	</div>
</div>
